"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ["MarketoOnly", "InteractionOnly", "Lead-PreAssigned", "Normal", "UserBypass", "SystemBypass"];
exports.default = _default;
//# sourceMappingURL=processing_type.js.map